export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11490.287f3968.jpg";